import React from 'react'
import {Row, Col} from 'react-bootstrap'
import {StaticImage} from 'gatsby-plugin-image'

import Section from '../components/Section'
import Counter from '../components/Counter'
import ContactGP from '../sections/ContactGP'
import LastingImpact from '../sections/LastingImpact'
import SpottingChickenpox from '../sections/SpottingChickenpox'
import {Footer} from '../components/Layout'
import SEO from '../components/SEO'

import FAQ from '../sections/FAQ'
import Intro from '../sections/Intro'
import Video from '../components/Video'
import ShareButton from '../components/ShareButton'
import ManagingSpots from '../sections/ManagingSpots'
import PossibleComplications from '../sections/PossibleComplications'
import Feedback from '../sections/Feedback'

const pageCertificate = {
  jobCode: 'GB-VVX-00299',
  dateOfPrep: 'November 2024',
}

export default function IndexRoute() {
  return (
    <>
      <SEO />
      <main className="content">
        <Intro />
        <Section id="basics" background="gray">
          <Row className="justify-content-between">
            <Col
              lg={6}
              xl={5}
              className="d-flex flex-column mb-5 mb-lg-0 text-center text-lg-start"
            >
              <h2 className="fs-1 fw-bold mb-4">
                Chickenpox:
                <br /> The Basics
              </h2>
              <p>
                The medical name for chickenpox is varicella because it is
                caused by the varicella zoster (VZ) virus. It’s a highly
                infectious disease, which means it’s easy to catch from someone
                who already has chickenpox.
              </p>
              <p>
                The good news is that, in most cases, once you’ve had it, your
                body is able to protect you from catching it again.
              </p>
              <div className="d-flex flex-column flex-lg-row gap-lg-3 mt-lg-3">
                <Counter
                  className="mt-4 mt-lg-0"
                  start={0}
                  end={90}
                  suffix="<sup>%</sup>"
                />
                <p className="mx-5 mx-lg-0 mt-lg-2 me-xxl-5">
                  of adults in the UK are immune to chickenpox because they had
                  the disease as a child.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <Video
                title="Video"
                videoUrl="https://players.brightcove.net/4090876667001/default_default/index.html?videoId=6317215354112"
              />
              {/* TODO Add share button */}
              <ShareButton
                className="mt-3"
                url="www.chickenpoxaware.co.uk"
                text="Share this video"
              />
            </Col>
          </Row>
        </Section>
        <SpottingChickenpox />
        <ManagingSpots />
        <Section
          id="pass-it-on"
          background="gray"
          className="text-center text-lg-start"
        >
          <Row>
            <Col lg={6}>
              <h2 className="fs-1 fw-bold mb-4">Don’t pass it on!</h2>
              <p>
                The medical name for chickenpox is varicella because it is
                caused by the varicella zoster (VZ) virus. It’s a highly
                infectious disease, which means it’s easy to catch from someone
                who already has chickenpox.
              </p>
              <p>
                The good news is that, in most cases, once you’ve had it, your
                body is able to protect you from catching it again.
              </p>
            </Col>
            <Col lg={6} className="align-self-end">
              <StaticImage
                className="mt-4 mt-lg-5"
                src="../assets/images/Ducks.png"
                alt="Duck with red dots alongisde three smaller ducks."
                width={650}
              />
            </Col>
          </Row>
        </Section>
        <Section id="stay-home" className="text-center text-lg-end">
          <Row className="gy-5 gy-lg-0">
            <Col
              lg={7}
              className="order-lg-2 d-flex flex-column justify-content-center gap-3 gap-lg-5"
            >
              <p className="fs-3 fw-bold">
                A little one with chickenpox will need around 5 days at home so
                you may have to take time off work to look after them.
              </p>
              <p>
                If you are due to take a flight, you may not be allowed to fly
                until the last blister has scabbed over, so check with the
                airline. If you are not contagious but the rash is still
                present, you may need a doctor’s certificate.
              </p>
            </Col>
            <Col
              lg={5}
              className="order-lg-1 d-flex justify-content-center mb-5 mb-lg-0"
            >
              <StaticImage
                src="../assets/images/Stay-at-home.png"
                alt="Girl waving her arm under 5 days at home icon"
                width={500}
              />
            </Col>
          </Row>
        </Section>
        <Section
          id="high-risk"
          background="gray"
          className="text-center text-lg-start"
        >
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <h2 className="fs-1 fw-bold mb-4">
                Be aware of
                <br />
                high-risk groups
              </h2>
              <p>
                Chickenpox is usually mild, but occasionally it can lead to
                serious complications, especially in adults, pregnant women,
                newborn babies and people with weakened immune systems.
              </p>
              <p>
                People in these high-risk groups are more likely to experience
                complications such as secondary infections. It’s rare to get
                chickenpox when you’re pregnant, and the chance of it causing
                complications is low. If you do get chickenpox when you’re
                pregnant, there’s a small risk of your baby being very ill when
                it’s born. Speak to a GP if you have not had chickenpox and have
                been near someone with it.
              </p>
              <p>
                It’s important to seek medical advice if you are in one of these
                groups and think you may have chickenpox.
              </p>
            </Col>
            <Col lg={6}>
              <StaticImage
                src="../assets/images/Girl-with-temperature.jpeg"
                alt="A child holding her forehead taking her temperature"
              />
            </Col>
          </Row>
        </Section>
        <PossibleComplications />
        <ContactGP />
        <LastingImpact />
        <Feedback />
        <FAQ />
      </main>
      <Footer certificate={pageCertificate} />
    </>
  )
}
